<div
    bsModal
    #createOrEditModal="bs-modal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="createOrEditModal"
    aria-hidden="true"
    [config]="{ backdrop: 'static' }"
>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form #paymentTypeForm="ngForm" novalidate (ngSubmit)="save()" autocomplete="off">
                <div class="modal-header">
                    <h4 class="modal-title">
                        <span *ngIf="paymentType.id">{{ l('EditPaymentType') }}</span>

                        <span *ngIf="!paymentType.id">{{ l('CreateNewPaymentType') }}</span>
                    </h4>

                    <button
                        type="button"
                        class="btn-close"
                        (click)="close()"
                        aria-label="Close"
                        [disabled]="saving"
                    ></button>
                </div>
                <div class="modal-body">

                    <div class="my-3">
                        <label class="form-label" for="PaymentType_Name">{{ l('Name') }} *</label>
                        <input
                            type="text"
                            #PaymentType_Name="ngModel"
                            id="PaymentType_Name"
                            class="form-control"
                            [(ngModel)]="paymentType.name"
                            name="Name"
                            required
                        />
                        <validation-messages [formCtrl]="PaymentType_Name"></validation-messages>
                    </div>

                    <div class="my5">
                        <label class="form-label" for="PaymentType_SortOrder">{{ l('SortOrder') }}</label>
                        <input
                            type="number"
                            #PaymentType_SortOrder="ngModel"
                            id="PaymentType_SortOrder"
                            class="form-control"
                            [(ngModel)]="paymentType.sortOrder"
                            name="SortOrder"
                        />
                        <validation-messages [formCtrl]="PaymentType_SortOrder"></validation-messages>
                    </div>
                    <!--
                    <div class="my-3">
                        <label class="form-label" for="PaymentType_Type">{{ l('Type') }}</label>
                        <input
                            type="text"
                            #PaymentType_Type="ngModel"
                            id="PaymentType_Type"
                            class="form-control"
                            [(ngModel)]="paymentType.type"
                            name="Type"
                        />
                        <validation-messages [formCtrl]="PaymentType_Type"></validation-messages>
                    </div>
                    -->
                    <div class="my-3">
                        <label class="form-label" for="ChartOfAccountName">{{ l('ChartOfAccount') }}</label>
                        <select name="paymentType.accountId" [(ngModel)]="paymentType.accountId" class="form-select">
                            <option value="">{{ l('SelectAChartOfAccount') }}</option>

                            <option *ngFor="let item of allChartOfAccounts" value="{{ item.id }}">
                                {{ item.displayName }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="modal-footer">
                    <button [disabled]="saving" type="button" class="btn btn-danger" (click)="close()">
                        {{ l('Cancel') }}
                    </button>
                    <button
                        type="submit"
                        class="btn btn-primary blue"
                        [disabled]="!paymentTypeForm.form.valid"
                        [buttonBusy]="saving"
                        [busyText]="l('SavingWithThreeDot')"
                    >
                        <i class="fa fa-save"></i>
                        <span>{{ l('Save') }}</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
